module.exports = __webpack_public_path__ + "static/media/measure2.4c0faa20.png";